import React from 'react'

interface TipCardProps {
  message?: string
  className?: string
}

const TipCard: React.FC<TipCardProps> = ({ 
  message = "",
  className = ""
}) => {
  return (
    <div className={`bg-[#F3F3F3] rounded-2 p-6 mb-7 flex items-center ${className}`}>
      <div className='w-4 h-4 bg-[#556AFF] text-2 rounded-full mr-4 text-white flex justify-center items-center'>
        i
      </div>
      <div className="flex-1">
        <div className="text-xs text-black leading-4">
          {message}
        </div>
      </div>
    </div>
  )
}

export default TipCard
